var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "url(#paint0_linear_265_1906)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.4375V17H24.25V24.4375C24.25 25.1758 23.6484 25.75 22.9375 25.75H13.3125C12.5742 25.75 12 25.1758 12 24.4375ZM20.75 19.0781V20.1719C20.75 20.3633 20.8867 20.5 21.0781 20.5H22.1719C22.3359 20.5 22.5 20.3633 22.5 20.1719V19.0781C22.5 18.9141 22.3359 18.75 22.1719 18.75H21.0781C20.8867 18.75 20.75 18.9141 20.75 19.0781ZM20.75 22.5781V23.6719C20.75 23.8633 20.8867 24 21.0781 24H22.1719C22.3359 24 22.5 23.8633 22.5 23.6719V22.5781C22.5 22.4141 22.3359 22.25 22.1719 22.25H21.0781C20.8867 22.25 20.75 22.4141 20.75 22.5781ZM17.25 19.0781V20.1719C17.25 20.3633 17.3867 20.5 17.5781 20.5H18.6719C18.8359 20.5 19 20.3633 19 20.1719V19.0781C19 18.9141 18.8359 18.75 18.6719 18.75H17.5781C17.3867 18.75 17.25 18.9141 17.25 19.0781ZM17.25 22.5781V23.6719C17.25 23.8633 17.3867 24 17.5781 24H18.6719C18.8359 24 19 23.8633 19 23.6719V22.5781C19 22.4141 18.8359 22.25 18.6719 22.25H17.5781C17.3867 22.25 17.25 22.4141 17.25 22.5781ZM13.75 19.0781V20.1719C13.75 20.3633 13.8867 20.5 14.0781 20.5H15.1719C15.3359 20.5 15.5 20.3633 15.5 20.1719V19.0781C15.5 18.9141 15.3359 18.75 15.1719 18.75H14.0781C13.8867 18.75 13.75 18.9141 13.75 19.0781ZM13.75 22.5781V23.6719C13.75 23.8633 13.8867 24 14.0781 24H15.1719C15.3359 24 15.5 23.8633 15.5 23.6719V22.5781C15.5 22.4141 15.3359 22.25 15.1719 22.25H14.0781C13.8867 22.25 13.75 22.4141 13.75 22.5781ZM22.9375 13.5C23.6484 13.5 24.25 14.1016 24.25 14.8125V16.125H12V14.8125C12 14.1016 12.5742 13.5 13.3125 13.5H14.625V12.1875C14.625 11.9688 14.8164 11.75 15.0625 11.75H15.9375C16.1562 11.75 16.375 11.9688 16.375 12.1875V13.5H19.875V12.1875C19.875 11.9688 20.0664 11.75 20.3125 11.75H21.1875C21.4062 11.75 21.625 11.9688 21.625 12.1875V13.5H22.9375Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_265_1906",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC1E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.1ed7a7a72e998bfb155ad3a464932a47.svg";
export { ForwardRef as ReactComponent };